import { neutrals, brand, text } from 'src/theme/colors';
import { StyleSheet } from 'react-native';
import { Stroke } from 'src/theme-v2/stroke';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { Alerts } from 'src/theme-v2/colors';
import { FOCUS_COLOR } from 'src/theme-v2/focus';

export const shared = StyleSheet.create({
  card: {
    flexDirection: 'column',
    gap: 8,
    borderRadius: 20,
  },
  image: {
    backgroundColor: '#CCCCCC',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  textBadge: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    color: neutrals.white,
  },
  badge: {
    position: 'absolute',
    top: 2,
    left: 2,
    flexDirection: 'row',
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    paddingVertical: 5,
    borderTopLeftRadius: 18,
    borderBottomRightRadius: 20,
    gap: 4,
    backgroundColor: brand.main.water,
  },
  icon: {
    width: 18,
    height: 18,
  },
  border: {
    borderWidth: 2,
    borderColor: Stroke.StrokeColor.StrokeColorNeutral,
    borderRadius: 20,
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  borderSelected: {
    borderColor: brand.main.water,
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  borderFocused: {
    borderColor: FOCUS_COLOR,
  },
  textDescription: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 16,
    color: neutrals.neutralGrays.cement,
  },
  radioButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    width: 23,
    height: 23,
    borderWidth: 2,
    borderRadius: 22,
    borderColor: neutrals.neutralGrays.aluminium,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: neutrals.white,
  },
  radioButtonSelected: {
    width: 11,
    height: 11,
    borderRadius: 11,
    backgroundColor: brand.main.water,
  },
  imageDisabled: {
    opacity: 0.6,
  },
  subTag: {
    backgroundColor: brand.main.mustard,
    position: 'absolute',
    top: 2,
    left: 2,
    flexDirection: 'row',
    paddingHorizontal: 8,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    paddingVertical: 4,
    borderTopLeftRadius: 18,
    borderBottomRightRadius: 18,
    gap: 4,
  },
  subTagText: {
    fontWeight: 700,
    fontSize: 10,
    lineHeight: 14,
    letterSpacing: 0,
    color: neutrals.white,
  },
});

export const stylesDesktop = StyleSheet.create({
  ...shared,
  textContainer: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  textWrapperLeft: {
    flex: 1,
    alignItems: 'flex-start',
  },
  textWrapperCenter: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textWrapperRight: {
    flex: 1,
    alignItems: 'flex-start',
    paddingHorizontal: 16,
  },
  price: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 18,
    color: neutrals.neutralGrays.graphite,
  },
  description: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 18,
    color: text.color.textTertiary,
  },
  descriptionSelected: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 18,
    color: brand.main.water,
  },
  textTitle: {
    fontWeight: 400,
    fontSize: 20,
    lineHeight: 26,
    color: neutrals.neutralGrays.graphite,
  },
  textTitleSelected: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
    color: neutrals.neutralGrays.graphite,
  },
  icon: {
    width: 18,
    height: 18,
    alignSelf: 'center',
  },
  textDescriptionLeft: {
    flex: 1,
    flexDirection: 'row',
    gap: 8,
    alignSelf: 'flex-start',
    paddingHorizontal: 16,
    minHeight: 36,
  },
  bottomContainer: { width: '100%', paddingTop: 16, paddingBottom: 24, gap: 4 },
});

export const stylesMobile = StyleSheet.create({
  ...shared,
  textContainer: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingTop: 8,
    paddingBottom: 4,
  },
  textWrapperLeft: {
    width: '100%',
    flex: 1,
    alignItems: 'flex-start',
  },
  textWrapperCenter: {
    width: '100%',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textWrapperRight: {
    width: '100%',
    flex: 1,
    alignItems: 'flex-start',
    paddingHorizontal: 8,
    paddingBottom: 4,
  },
  price: {
    fontWeight: 400,
    fontSize: 14,
    color: neutrals.neutralGrays.graphite,
  },
  description: {
    ...textLatoStyleDS.BodyRegularSm,
    color: text.color.textTertiary,
  },
  descriptionSelected: {
    ...textLatoStyleDS.BodyRegularSm,
    color: text.color.textTertiary,
  },
  textTitle: {
    ...textLatoStyleDS.TitleBoldXl,
    color: neutrals.neutralGrays.graphite,
  },
  textTitleSelected: {
    ...textLatoStyleDS.TitleBoldXl,
    color: neutrals.neutralGrays.graphite,
  },
  icon: {
    width: 15,
    height: 15,
    alignSelf: 'center',
  },
  textDescriptionLeft: {
    flexDirection: 'row',
    gap: 8,
    alignSelf: 'flex-start',
    paddingHorizontal: 8,
    minHeight: 36,
  },
  bottomContainer: { width: '100%', paddingTop: 16, paddingBottom: 16 },
});
